import { Typography, styled as muiStyled } from '@mui/material';
import styled from 'styled-components';
import { abyssColors } from '@/theme/colors';

export const SummaryTitle = muiStyled(Typography)({
  fontSize: '1.6rem',
  fontWeight: 500,
  color: abyssColors.primary[600],
  lineHeight: '24px',
  margin: '0px !important',
});

export const SummarySubTitle = muiStyled(Typography)({
  fontSize: 14,
  fontWeight: 500,
  color: abyssColors.primary[500],
  lineHeight: 'normal',
  letterSpacing: '0.1px',
  marginTop: '24px',
});

export const CheckboxLabel = muiStyled(Typography)({
  fontSize: '1.4rem',
  color: abyssColors.primary[500],
  lineHeight: 'normal',
});

export const PaintBlockCheckboxStyles = {
  '& .MuiCheckbox-root.Mui-checked,': {
    color: `${abyssColors.primary[500]} !important`,
  },
  '& .MuiSvgIcon-root': { fontSize: '2rem' },
};

interface TabProps {
  selected: boolean;
}

export const ConditionTab = styled.div<TabProps>`
  padding: 4px 14px;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.selected ? abyssColors.neutral[50] : abyssColors.primary[500])};
  background: ${(props) => (props.selected ? abyssColors.primary[500] : 'transparent')};
  height: 26px;
  width: fit-content;
  cursor: pointer;
`;

export const POIDialogTab = styled.div<TabProps>`
  display: flex;
  align-items: center;
  padding: 2px 12px;
  border-radius: 4px;
  border: 1px solid #B8CADD;
  justify-content: center;
  align-items: center;
  background: ${(props) => (props.selected ? abyssColors.primary[100] : 'transparent')};
  height: 26px;
  width: fit-content;
  cursor: pointer;
  font-weight = ${(props) => (props.selected ? 700 : 400)};
`;
